import { render } from "./ProfileContent.vue?vue&type=template&id=0884890c"
import script from "./ProfileContent.vue?vue&type=script&lang=js"
export * from "./ProfileContent.vue?vue&type=script&lang=js"

import "./ProfileContent.vue?vue&type=style&index=0&id=0884890c&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__